import { render, staticRenderFns } from "./tempSendPreviewModel.vue?vue&type=template&id=16e5c285&lang=pug&"
import script from "./tempSendPreviewModel.vue?vue&type=script&lang=js&"
export * from "./tempSendPreviewModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports